import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Input} from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppCoreService } from 'src/app/services/app-core.service';
import { AWBService } from 'src/app/services/operations/awb.service';
import { FileHandlerService } from 'src/app/services/file-handler.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss']
})

export class UploadDocumentComponent implements OnInit {
  modelForm: FormGroup;
  @Input() public cellAWbnumber: any;
  isFormSubmitted = false;
  uploadedFile: File | null = null;
  selectedSCId: number;
  uploadedFileId: number;
  documentTypeList: any[];

  constructor(
    private appCoreService: AppCoreService,
    public activeModal: NgbActiveModal,
    private ngxLoaderService: NgxUiLoaderService,
    private fileHandlerService: FileHandlerService,
    private _fb: FormBuilder,
    private awbService: AWBService,
    private titleService: Title
  ) {
    titleService.setTitle('Air Way Bill');
   }

  ngOnInit() {
    this.documentTypeList = [{name : 'Form 5', value : 'form5'},{name : 'Other Document', value : 'otherdocument'} ];
    this.modelForm = this._fb.group({
        txtTitle: [null, Validators.required],
        ddlDocumentType: [null, Validators.required],
        fileControl: [null, Validators.required]
    });
  }

  addDocument(fileid){
    if (this.modelForm.valid) {
        
        let requestObj ={
            title : this.modelForm.get('txtTitle').value,
            fileid,
            awbnumber: this.cellAWbnumber,
            doctype: this.modelForm.get('ddlDocumentType').value
        }        
        this.ngxLoaderService.start();
        try {
          this.awbService.UploadDocument(requestObj).subscribe(res => {
            if (res?.success) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage('Status updated successsfully', 'Success', 'success');
              this.resetFrom();
              this.activeModal.close('Save Click');
              
            } else if (res && !res.sucess) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage(res.message, 'Error', 'error');
            }
          })
        } catch (error) {
          this.ngxLoaderService.stop();
        }
    }
  }

  onChangeFileSelect(evt) {
    try {
      if (evt) {
          this.uploadedFile = evt.target.files[0];
      }
    } catch (e) {
      console.error(e);
    }
  }

  uploadFile() {
    try {
        if (this.uploadedFile) {
          let requestObj = {
            name: this.uploadedFile.name,
            fileType: this.uploadedFile.type,
            category: 'Customer'
          };

          this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
            try {
              if (res && res.success) {
                const signedUrl = res.data.uploadURL;
                const fileId = res.data.fileId;
                this.uploadedFileId = fileId;
                if (signedUrl) {
                  let headers: HttpHeaders = new HttpHeaders({
                    "Content-Type": requestObj.fileType
                  });

                  this.fileHandlerService.UploadFile(signedUrl, this.uploadedFile, headers).subscribe((f) => {
                    if (f === null) {
                      this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                        if (res && res.success) {
                          //this.modelForm.get('uploadedFileControl').setValue(fileId);
                          this.appCoreService.showMessage('File uploaded successfully','Success','success');
                          this.addDocument(fileId)
                        }
                      });
                    }
                  });
                }
              }
            } catch (error) {
              console.error(error);
            }
          });
        } else {
          this.appCoreService.showMessage('Please select a file to upload', '', 'error');
        }

    } catch (e) {
      console.error(e);
    }
  }

  resetFrom() {
    this.isFormSubmitted = false;
    this.modelForm.reset();
  }
}